import quote from "./quote/index"
import ads from "./ads"
export default {
	quote,
	ads
}